import React, { FC } from 'react';
import { Box, Typography, FormGroup, FormControlLabel, Checkbox } from '@mui/material';
import { FormField, EnumOptions } from '../../models/training.models';

interface EnumFieldComponentProps {
  field: FormField;
  value: string[];
  onChange: (value: string[]) => void;
  disabled?: boolean;
}

const EnumFieldComponent: FC<EnumFieldComponentProps> = ({ field, value, onChange, disabled = false }) => {
  const options = (field.options as EnumOptions)?.options || [];

  const handleToggle = (option: string) => {
    if (disabled) return;

    if (value.includes(option)) {
      onChange(value.filter((v) => v !== option));
    } else {
      onChange([...value, option]);
    }
  };

  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="subtitle1" sx={{ mb: 2 }}>
        {field.name}
      </Typography>
      <FormGroup>
        {options.map((option) => (
          <FormControlLabel
            key={option}
            control={
              <Checkbox checked={value.includes(option)} onChange={() => handleToggle(option)} disabled={disabled} />
            }
            label={option}
          />
        ))}
      </FormGroup>
    </Box>
  );
};

export default EnumFieldComponent;
